const zh: Record<string, string> = {
  "Virtual Try-On": "虚拟试穿",
  "Find Your Size & See It On You": "找到你的尺码并试穿",
  "See Your Fit": "查看合身效果",
  "Check your size, then try it on virtually": "确认尺码，然后虚拟试穿",
  "Get Your Size": "获取尺码",
  "Instant fit suggestion": "即时合身建议",
  "Try It On": "试穿",
  "See how it looks on you": "看看穿在你身上的效果",
  "Find My Size": "找到我的尺码",
  "Takes less than a minute": "不到一分钟",
  "Upload a full body photo": "上传全身照",
  "JPEG, PNG or WebP (max 10MB)": "JPEG、PNG 或 WebP（最大10MB）",
  "Your photo": "你的照片",
  "Let's find your best fit": "找到最适合你的尺码",
  "Centimeters": "厘米",
  "Inches": "英寸",
  "Load saved profile...": "加载已保存的档案...",
  "HEIGHT": "身高",
  "WEIGHT": "体重",
  "feet": "英尺",
  "inches": "英寸",
  "cm": "厘米",
  "kg": "公斤",
  "lbs": "磅",
  "in": "英寸",
  "How to measure": "如何测量",
  "Hide guide": "隐藏指南",
  "I know my measurements": "我知道我的尺寸",
  "Not sure? Use height & weight instead": "不确定？使用身高和体重",
  "Please fill in height and weight": "请填写身高和体重",
  "Please fill in all required fields": "请填写所有必填项",
  "Next": "下一步",
  "Analyzing your size...": "正在分析你的尺码...",
  "SUGGESTED SIZE": "建议尺码",
  "NOT SUGGESTED": "不建议",
  "Edit measurements": "编辑尺寸",
  "Size guide": "尺码指南",
  "Your fit": "你的合身度",
  "Your Suggested Size": "你的建议尺码",
  "Your measure": "你的尺寸",
  "within range": "在范围内",
  "too tight": "太紧",
  "tight": "偏紧",
  "a bit tight": "略紧",
  "too loose": "太松",
  "loose": "偏松",
  "a bit loose": "略松",
  "See fit on your photo": "在照片上查看合身度",
  "Hide visual fit": "隐藏合身显示",
  "Analyzing...": "分析中...",
  "Try it on": "试穿",
  "SIZE CHART": "尺码表",
  "YOUR ESTIMATED MEASUREMENTS": "你的预估尺寸",
  "Edit": "编辑",
  "Download": "下载",
  "Size chart": "尺码表",
  "Preparing your image...": "正在准备图片...",
  "Analyzing body proportions...": "正在分析体型...",
  "Matching garment to your photo...": "正在将服装匹配到照片...",
  "Generating virtual try-on...": "正在生成虚拟试穿...",
  "Refining details...": "正在优化细节...",
  "Almost there...": "即将完成...",
  "Complete!": "完成！",
  "This usually takes 15-25 seconds": "通常需要15-25秒",
  "Something went wrong": "出错了",
  "Try Again": "重试",
  "We couldn't find a matching size for you": "我们无法为你找到匹配的尺码",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "请尝试手动测量页面，我们会根据你的测量数据计算合身度。",
  "Try manual measurements": "尝试手动测量",
  "SDK not configured. Please provide an API key.": "SDK未配置，请提供API密钥。",
  "Please upload a JPEG, PNG, or WebP image.": "请上传JPEG、PNG或WebP图片。",
  "Image must be under 10MB.": "图片必须小于10MB。",
  "Try-on generation failed": "试穿生成失败",
  "Failed to start try-on": "无法开始试穿",
  "No product image found. Please set the product-image attribute.": "未找到商品图片，请设置product-image属性。",
  "Powered by": "技术支持",
  "My Profiles": "我的档案",
  "History": "历史记录",
  "No saved profiles yet.": "还没有保存的档案。",
  "No history yet.": "还没有历史记录。",
  "Product": "商品",
  "Women's": "女装",
  "Men's": "男装",
  "Profiles": "档案",
  "Women's Profile": "女性档案",
  "Men's Profile": "男性档案",
  "Height": "身高",
  "Weight": "体重",
  "Chest": "胸围",
  "Bust": "胸围",
  "Waist": "腰围",
  "Hips": "臀围",
  "Shoulders": "肩宽",
  "Sleeve": "袖长",
  "Inseam": "内缝",
  "Neck": "颈围",
  "Foot": "脚",
  "Shoe EU": "鞋码 EU",
  "Shoe US": "鞋码 US",
  "Shoe UK": "鞋码 UK",
  "Saved": "已保存",
  "Delete Profile": "删除档案",
  "Shoe size (US)": "鞋码（US）",
  "Shoe size (UK)": "鞋码（UK）",
  "Shoe size (EU)": "鞋码（EU）",
  "Generating...": "生成中...",
  "Foot length": "脚长",
  "Size": "尺码",
  "Try on size": "试穿尺码",
  "e.g.": "例如",
  "Drop your photo here or click to upload": "将照片拖放到此处或点击上传",
  "This usually takes 15-20 seconds": "通常需要15-20秒",
  "Try-on result": "试穿结果",
  "Try Another": "再试一次",
  "Back": "返回",
  "You": "你的",
  "Garment": "服装",
  "Your Height": "你的身高",
  "Your Weight": "你的体重",
  "Drag or scroll to set your height": "拖动或滚动设置身高",
  "Drag or scroll to set your weight": "拖动或滚动设置体重",
  "Enter height and weight first": "请先输入身高和体重",

  // ── Field labels ──
  "Lens Width": "镜片宽度",
  "Bridge": "鼻梁",
  "Arm Length": "镜腿长度",
  "Head Circumference": "头围",
  "Face Width": "脸宽",
  "Temple": "镜腿",
  "Around widest point": "围绕最宽处",
  "Foot Length": "脚长",
  "Shoulder": "肩宽",
  "Thigh": "大腿",
  "Hip": "臀部",

  // ── Units ──
  "Millimetre": "毫米",
  "Centimetre": "厘米",
  "Millimeters": "毫米",

  // ── Fit descriptors ──
  "Tight": "紧",
  "Loose": "松",
  "Short": "短",
  "Long": "长",
  "✓ Fit": "✓ 合身",
  "too short": "太短",
  "too long": "太长",
  "a bit short": "稍短",
  "a bit long": "稍长",

  // ── Length pills ──
  "Length": "长度",
  "Length Adjustment": "长度调整",
  "Regular": "标准",
  "Big": "大",
  "Big & Tall": "大号加长",

  // ── Misc ──
  "preview": "预览",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "上传您的照片",
  "Upload a photo": "上传照片",
  "Click or drag a full-body photo": "点击或拖入全身照",
  "Or upload a photo for AI sizing": "或上传照片以进行AI尺寸分析",
  "Photo": "照片",
  "How to take a good photo": "如何拍出好照片",
  "How to take the best photo": "如何拍出最佳照片",
  "Do": "建议",
  "Don't": "避免",
  "Quick Tip": "小提示",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "照片越简洁,虚拟试穿的结果越准确。",
  "Choose a plain background (a light wall is ideal)": "选择简洁背景(浅色墙面最理想)",
  "Stand facing the camera with your full body in frame": "面向相机站立,全身入镜",
  "Stand straight and still, arms relaxed by your sides": "保持站直不动,双臂自然放松",
  "Stand with your HEELS against a wall for best accuracy": "脚后跟靠墙站立以获得最佳准确度",
  "Use natural or even lighting (e.g. near a window)": "使用自然光或均匀光线(例如靠近窗户)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "穿合身简洁的衣服(例如纯色)",
  "Don't wear loose, baggy, or layered clothing": "不要穿宽松或多层叠加的衣服",
  "Don't sit, pose, or bend your body": "不要坐着、摆姿势或弯腰",
  "Don't use strong backlighting": "不要使用强烈逆光",
  "Don't take mirror photos or selfies": "不要拍镜子照或自拍",
  "Don't apply filters, effects, or edits": "不要使用滤镜、特效或修图",

  // ── Age gate ──
  "Are you 18 or older?": "您年满18岁吗?",
  "Yes": "是",
  "No": "否",
  "Please confirm your age": "请确认您的年龄",
  "Please confirm that the person in the photo is 18 or older before uploading.": "上传前请确认照片中的人已年满18岁。",
  "Under 18 — can't process this photo.": "未满18岁 — 无法处理此照片。",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "此照片似乎是未成年人。请上传18岁或以上人士的照片。",
  "Different photo needed": "需要其他照片",
  "Try another photo": "尝试其他照片",

  // ── Photo step controls ──
  "Continue": "继续",
  "Analyze My Size": "分析我的尺寸",
  "Analyzing photo…": "正在分析照片…",
  "Details": "详情",
  "Image must be under 10MB": "图片必须小于10MB",
  "Please upload an image file": "请上传图片文件",
  "Please upload a photo": "请上传照片",
  "Prefer not to upload a photo?": "不想上传照片?",
  "Enter measurements manually": "手动输入尺寸",
  "Legal Notice": "法律声明",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "您的图片将用于生成虚拟试穿预览,显示所选商品的外观和合身效果。图片以安全方式处理,生成后不会保存。",

  // ── BodyProfileView — form (right section) ──
  "Body details": "身体信息",
  "Your body details": "您的身体信息",
  "Body Measurements": "身体尺寸",
  "AGE": "年龄",
  "years": "岁",
  "Enter your height": "输入您的身高",
  "Enter your weight": "输入您的体重",
  "Enter your bra size": "输入您的内衣尺码",
  "Please enter your height": "请输入您的身高",
  "Please enter your weight": "请输入您的体重",
  "Please enter a valid height": "请输入有效的身高",
  "Please enter a valid weight": "请输入有效的体重",
  "Please enter a valid height (100-250 cm)": "请输入有效的身高(100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "请输入有效的体重(30-300 kg)",
  "Please select both band and cup size": "请选择下围和罩杯尺寸",
  "Select your bra size": "选择您的内衣尺码",
  "BAND": "下围",
  "BAND SIZE": "下围尺寸",
  "CUP": "罩杯",
  "CUP SIZE": "罩杯尺寸",
  "BRA REGION": "内衣地区",
  "Imperial": "英制",
  "Metric": "公制",
  "These calibrate the AI — all required.": "这些用于校准AI — 均为必填项。",
  "Using": "使用中",
  "start fresh": "重新开始",
  "Close": "关闭",

  // ── Body shape questions ──
  "Which best describes your chest?": "哪个最能描述您的胸部?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "哪个最能描述您的胸部?",
  "Which best describes your hips?": "哪个最能描述您的臀部?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "哪个最能描述您的臀部?",
  "Which best describes your midsection?": "哪个最能描述您的腰部?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "哪个最能描述您的腰部?",
  "Which best describes your seat?": "哪个最能描述您的臀部?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "哪个最能描述您的臀部?",
  "Average": "平均",
  "Narrow": "窄",
  "Broad": "宽",
  "Curvy": "曲线",
  "A slimmer, narrower chest build": "较瘦较窄的胸部",
  "A moderate, proportionate chest": "适中匀称的胸部",
  "A wider, more muscular chest": "较宽较结实的胸部",
  "A flatter midsection with minimal protrusion": "较平坦的腰部",
  "A moderate, natural midsection shape": "适中自然的腰部",
  "A fuller, more rounded midsection": "较丰满圆润的腰部",
  "A flatter backside with less projection": "较平坦的臀部",
  "A moderate, natural backside shape": "适中自然的臀部",
  "A fuller, more rounded backside": "较丰满圆润的臀部",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "已从个人资料加载",
  "Clear": "清除",
};
export default zh;
